const topbar = {
    docs: 'Docs',
    help: 'Help',
    subscription: 'Subscription',
};
export default Object.freeze(topbar);
